import { createGlobalState } from 'react-hooks-global-state';

const initialState = {
    ...window.initialState,
    firstLoadFinished: false
}

const { useGlobalState } = createGlobalState(initialState);
export { useGlobalState };

export function isMobile() {
    return navigator.userAgent.toLowerCase().match("(android|avantgo|blackberry|bolt|boost|cricket|docomo|fone|hiptop|mini|mobi|palm|phone|pie|tablet|up\.browser|up\.link|webos|wos)")
        || window.matchMedia("(max-width: 767px)").matches;
}

export function jsonToFormData(json) {
    const formData = new FormData();
    for(const key in json) {
        if(key === 'filters' || key === 'dfilters') {
            json[key].split('&').filter(f => f.includes('=')).map((filter) => {
                formData.append(filter.split('=')[0], filter.split('=')[1]);
            });
        }
        else {
            formData.append(key, json[key]);
        }
    }
    return formData;
}


export const FiltersConfigParam = {
    encode: (obj) => {
        let filtersStr = "";
        for(const key in obj) {
            if(key === 'retail_price' || key === 'carat_weight' || key === 'credit_card_price' || key === 'carat') {
                if(obj[key].min !== obj[key].default_min) filtersStr += `&filters[${key}][min]=${obj[key].min}`
                if(obj[key].max !== obj[key].default_max) filtersStr += `&filters[${key}][max]=${obj[key].max}`
            } else {
                obj[key].map((val) => {
                    filtersStr += `&filters[${key}][]=${val.replace(new RegExp(' ', 'g'), '_').toLowerCase()}`
                })
            }
        }
        return filtersStr;
    },
    decode: (str) => {},
    equals: (currentValue, newValue) => JSON.stringify(currentValue) === JSON.stringify(newValue)
}

export const DFiltersConfigParam = {
    encode: (obj) => {
        let filtersStr = "";
        for(const key in obj) {
            if(key === 'marked_price' || key === 'carat' || key === 'depth' || key === 'table_pct' || key === 'ratio') {
                if(obj[key].min !== obj[key].default_min) filtersStr += `&dfilters[${key}][min]=${obj[key].min}`
                if(obj[key].max !== obj[key].default_max) filtersStr += `&dfilters[${key}][max]=${obj[key].max}`
            } else {
                obj[key].map((val) => {
                    filtersStr += `&dfilters[${key}][]=${val.replace(new RegExp(' ', 'g'), '_').toLowerCase()}`
                })
            }
        }
        return filtersStr;
    },
    decode: (str) => {},
    equals: (currentValue, newValue) => JSON.stringify(currentValue) === JSON.stringify(newValue)
}
